import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

const useIsDuplicateSupplierNameApi = (poId: string) => {
  const execute = useCallback(
    (supplierName: string) =>
      new Promise<boolean>((resolve, reject) => {
        axiosInstance
          .get<boolean>(api.isDuplicateSupplierName(poId), { params: { supplierName } })
          .then((data) => {
            resolve(data.data);
          })
          .catch((reason) => {
            reject(reason.error);
          });
      }),
    [poId]
  );

  return { execute };
};

export default useIsDuplicateSupplierNameApi;
